import { MapTrackingGpsPoints, WaybillMapStop } from '../../common/models/map-tracking-points.model';
import { TransportMode } from '../../common/constants/transport-mode';

export class WaybillTrackingMap {
  transportMode: TransportMode;
  mapData: MapTrackingGpsPoints<WaybillMapStop>;
}
